import { tools } from '@worktango/ai-assistant/react';
import { fetchCurrentAccountQuery } from '~/behaviors/react-query/account';
import { fetchFindSurveysQuery } from '~/behaviors/react-query/reporting';
import { fetchCompanySurveyTypesQuery } from '~/behaviors/react-query/surveyTypes';

export const listRelatedFactorsTool = tools.createTool({
  name: 'list_related_factors',
  description: 'List all factors/categories related to a survey type or a survey (through its survey type)',
  displayName: 'Analyzing related factors',
  pastTenseDisplayName: 'Analyzed related factors',
  parameters: (t) =>
    t.Object({
      surveyTypeId: t.Optional(t.Number({ description: 'The survey type id' })),
      surveyId: t.Optional(t.Number({ description: 'The survey id' })),
    }),
  fulfill: async (args) => {
    let { surveyTypeId, surveyId } = args;

    if (!surveyTypeId && !surveyId) {
      return JSON.stringify({ error: 'Either surveyTypeId or surveyId must be provided' });
    }

    const { account } = await fetchCurrentAccountQuery();

    const hasSurveyId = !!surveyId;
    const hasSurveyTypeId = !!surveyTypeId;

    if (!hasSurveyTypeId && hasSurveyId) {
      const surveys = await fetchFindSurveysQuery([surveyId]);

      if (surveys.length === 0) {
        return JSON.stringify({ error: 'Survey not found' });
      }

      surveyTypeId = surveys?.[0]?.types?.[0]?.id;
    }

    const surveyTypes = await fetchCompanySurveyTypesQuery({ companyId: account.companyId, lang: account.lang });

    const surveyType = surveyTypes.find((surveyType) => surveyType.id === surveyTypeId);

    if (!surveyType) {
      return JSON.stringify({ error: 'Survey type not found' });
    }

    const factors = surveyType.categories;

    return JSON.stringify(factors);
  },
});
